import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

// Echter Systemstatus aus /api/system/status (Server-Prüfungen). Keine erfundenen Werte.
const Ctx = createContext(null);

export function SystemStatusProvider({ children }) {
  const [state, setState] = useState({ phase: "loading", data: null });
  const [panelOpen, setPanelOpen] = useState(false);

  const check = useCallback(() => {
    setState((s) => ({ ...s, phase: "loading" }));
    api.get("/system/status")
      .then((r) => setState({ phase: "ready", data: r.data }))
      .catch((e) => setState({ phase: e?.response?.status === 403 ? "forbidden" : "error", data: null }));
  }, []);

  useEffect(() => { check(); }, [check]);

  const value = useMemo(() => ({ ...state, check, panelOpen, setPanelOpen }), [state, check, panelOpen]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useSystemStatus = () => useContext(Ctx);

// Segmente für Badge/Drawer: nur echte Zählungen; nie ein grünes Gesamt-Signal.
export function statusSegments({ phase, data }) {
  if (phase === "loading") return [{ k: "pending", n: null }];
  if (phase === "forbidden") return [{ k: "unk", n: null }];
  if (phase === "error" || !data?.summary) return [{ k: "fail", n: null }];
  const s = data.summary;
  return [["fail", s.fail], ["ok", s.ok], ["unk", s.unknown]].filter(([, n]) => n > 0).map(([k, n]) => ({ k, n }));
}
